// import logo from './logo.svg';
// import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/antd.min.css';
import RouteList from './routes';
import './style/scss/main.scss'

function App() {
  return (
    <RouteList/>
  );
}

export default App;
